export default {
  /**
   * 埋点指令，用于在模板中进行指令埋点
   * 包含事件埋点（如: click)和曝光埋点
   * @param {function} callback 埋点行为触发之后的回调函数
   * @param {string} [options={ callback: function () {} }]
   */
  install(Vue, options = {}) {
    if (!options.callback) {
      console.log('埋点必须指定埋点触发回调函数（callback)')
      return
    }

    const callback = options.callback

    // 监听器，新曝光模式: 资源位漏出的高度和宽度比例大于等于50%
    const iOptions = {
      threshold: [0.5]
    }
    const newIO = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // 元素进入视口，触发埋点
        // console.log(entry.intersectionRatio)

        if (entry.intersectionRatio > 0.5) {
          const specialParams = entry.target.dataset['showparamsapp']
          callback(JSON.parse(specialParams))
        }
      })
    }, iOptions)

    Vue.directive('exptrack', {
      bind(el, binding) {
        const value = binding.value

        if (!value) return

        const items = Object.prototype.toString.call(value) === '[object Array]' ? value : [value]
        items.forEach(item => {
          let actType = item.act || 'click'
          let params = item.params

          if (!params) return

          el.dataset[actType + 'paramsapp'] = JSON.stringify(params)

          if (actType === 'show') {
            newIO.observe(el)
          } else {
            el.addEventListener(
              actType,
              () => {
                const params = el.dataset[actType + 'paramsapp']
                callback(JSON.parse(params))
              },
              true
            )
          }
        })
      },
      update(el, binding) {
        const value = binding.value

        if (!value) return

        const items = Object.prototype.toString.call(value) === '[object Array]' ? value : [value]
        items.forEach(item => {
          let actType = item.act || 'click'
          let params = item.params

          if (!params) return

          el.dataset[actType + 'paramsapp'] = JSON.stringify(params)
        })
      },
      unbind(el, binding) {
        newIO.unobserve(el)
      }
    })
  }
}
